import { render, staticRenderFns } from "./IconText.vue?vue&type=template&id=efdd56e2&scoped=true"
import script from "./IconText.vue?vue&type=script&lang=js"
export * from "./IconText.vue?vue&type=script&lang=js"
import style0 from "./IconText.vue?vue&type=style&index=0&id=efdd56e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdd56e2",
  null
  
)

export default component.exports